export class ForgetPasswordModel {
    userName: string;
    usernameType: number = 2;
}